import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useSectionColumns from "./useSectionColumns";

const NewSectionColumn = (props) => {
  const { SectionColumns } = useSectionColumns();

  const createColumn = _.debounce(() => {
    SectionColumns.create(props.section, (section_column) => {
      dispatchCustomEvent("focusItem", {
        parent_id: props.section.id,
        item_type: "section_columns",
        item_id: section_column.id,
      });
    });
  }, 200);

  if (props.canvasPlaceholder) {
    return (
      <div
        className="cf-cta-item-container"
        section-id={props.section.id}
        data-section-id={props.section.id}
      >
        <div className="cf-cta-item disabled-item"></div>
        <p
          className="cf-draggable-creation-hover empty-container"
          onClick={createColumn}
          style={{ cursor: "pointer" }}
        >
          + Add Column
        </p>
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={createColumn}
      className="w-full p-2 text-left bg-transparent border-none text-xl cursor-pointer text-blue-600 dark:text-blue-200 dark:hover:text-white"
    >
      <FontAwesomeIcon icon="plus-square" className="mr-2" /> Add Column
    </button>
  );
};

export default NewSectionColumn;
